<template>
	<div v-if="order && order.shipment && isShipped">
		<span>Codice di tracciamento: </span>
		<a
			class="link-detail"
			:href='trackingLink(order)'
			target="_blank"
			v-html="order.shipment.tracking_code"
		/>
	</div>
</template>

<script>
import { deliveryStore } from '../../store/deliveryStore'

const moment = require('moment')

export default {
	props: {
		order: {
			type: Object,
			default () {
				return null
			}
		}
	},

	data () {
		return {
			deliveryStore: deliveryStore.state,
			config: {
				milkmanBaseTrackingLink: 'https://app.milkman.it/webApp/#/it/etaservice?trackingId=',
				sdaBaseTrackingLink: 'https://www.sda.it/SITO_SDA-WEB/dispatcherHol?execute2=ActionTracking.doGetSpedizioneSelfTrck&id_cliente=000000000000&id_ldv='
			}
		}
	},

	watch: {
		order () {
			this.loadDelivery()
		}
	},

	computed: {
		delivery () {
            var order = this.order
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +order.id)
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +order.id).attributes
        },

		isShipped () {
			if (!this.delivery) return
			var shipmentDayAfter20 = moment(this.order.date.week_plan)
				.add(this.delivery.shipment_day - 1 + 7, 'days')
				.hour(20)
				.locale('it')
				.format()
			var now = moment()
				.locale('it')
				.format()
			return this.order.is_paid && now > shipmentDayAfter20
		},
	},

	methods: {
		trackingLink (order) {
			if (!order.shipment) return
			var link = order.shipment.parcel_code
				&& order.shipment.parcel_code
					.toLowerCase()
					.includes('mlk')
				? this.config.milkmanBaseTrackingLink
				: this.config.sdaBaseTrackingLink
			return link + order.shipment.tracking_code
		},

		loadDelivery () {
			if (!this.order) return
        	return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.order.id
	    	})
        }
	},

	mounted () {
		this.loadDelivery()
	}
}

</script>

<style scoped>

</style>
